<template>
  <div class="part-life-bd tb" v-if="funcView.part_life_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
           <search-input
            :placeholder="$t('asm_part_life.ljmcljbhcpxh')"
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        index
        :column="tableColumn"
        :data="tableList"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['action']"
      >
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editEvent(scope.row)" v-if="funcView.part_life_set_theory_use_time">{{funcView.part_life_set_theory_use_time}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <part-life-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="onPageChange({ page: 1 })"
    ></part-life-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partLifeDialog from './children/part_life_dialog.vue';

export default {
  components: { partLifeDialog },
  name: 'partLife',
  data() {
    return {
      provide: true,
      tableCode: 'part_life',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        isLifeLimit: 1
      },

      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {}
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 编辑
    editEvent: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_part_life.szllsm');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.PartPage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  }
};
</script>

<style lang='scss' scoped>
@import "style/colors.scss";

.part-life-bd {
}
</style>
